import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function InquiryForm({ artworkId, artworkTitle, onSuccess }) {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please complete all fields.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/inquiries", {
        ...form,
        artwork_id: artworkId || null,
        artwork_title: artworkTitle || null,
      });
      toast.success("Your message has reached the artist.", {
        description: "A reply will arrive within a few days.",
      });
      setForm({ name: "", email: "", message: "" });
      onSuccess && onSuccess();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Could not send. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-6" data-testid="inquiry-form">
      {artworkTitle && (
        <p className="plaque-label" data-testid="inquiry-artwork-label">
          Regarding · {artworkTitle}
        </p>
      )}
      <div>
        <label className="plaque-label">Your Name</label>
        <input
          type="text"
          className="line-input"
          value={form.name}
          onChange={update("name")}
          placeholder="Jane Doe"
          data-testid="inquiry-name-input"
        />
      </div>
      <div>
        <label className="plaque-label">Email</label>
        <input
          type="email"
          className="line-input"
          value={form.email}
          onChange={update("email")}
          placeholder="you@example.com"
          data-testid="inquiry-email-input"
        />
      </div>
      <div>
        <label className="plaque-label">Message</label>
        <textarea
          className="line-input resize-none"
          rows={5}
          value={form.message}
          onChange={update("message")}
          placeholder="I'd like to know more about availability, pricing, or arrange a viewing."
          data-testid="inquiry-message-input"
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        className="group inline-flex items-center gap-3 text-xs tracking-[0.3em] uppercase border border-[#D4AF37]/40 hover:border-[#D4AF37] px-6 py-4 text-[#D4AF37] transition-colors disabled:opacity-50"
        data-testid="inquiry-submit-button"
      >
        {submitting ? "Sending…" : "Send Message"}
        <span className="transition-transform group-hover:translate-x-1">→</span>
      </button>
    </form>
  );
}
